import { css } from 'emotion';
import chroma from 'chroma-js';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    paddingBottom: '2px',
    color: '#7A6ABB',
    borderBottom: '1px solid #7A6ABB',
    transition: animationTransition('color'),
    ':hover': {
      color: chroma('#7A6ABB')
        .darken()
        .css()
    }
  });
}
